import styled from "styled-components";

import { theme } from "../../themes/themes";
export const SecondaryWrapper = styled.div`
  display: grid;
  grid-auto-rows: 0.2fr 100px;
  align-items: center;
  border-radius: 1px;
  textarea {
    resize: none;
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 30px;
    color: ${({ theme }) => theme.primaryIconColor};
  }
  svg {
    width: 20px !important;
  }
`;

export const SelectStyles = {
  dropdownIndicator: (base) => ({
    ...base,
    fontSize: "10em",
  }),
  control: (styles, { isFocused }) => ({
    ...styles,
    boxShadow: isFocused ? "#ffbbdc33" : theme.neutral.gray[700],
    borderColor: theme.neutral.gray[700],
    ":hover": {
      ...styles[":hover"],
      borderColor: "#ffbbdc33",
    },
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#ffbbdc33" : data.color,
      ":hover": {
        ...styles[":hover"],
        backgroundColor: "#ffbbdc33",
      },
      color: isFocused ? theme.button.primary : data.color,
    };
  },
};
